export default __webpack_public_path__ + "static/media/shareInsta.e3df3f02.svg";